module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox@3x-18facf73cedf2faa74bf2094ce361448.png";